// VIEW PILL — the one tab control for every screen (James 2026-10-09: "one tab style, the release grid's,
// always in the same place"). A single dark pill in the top bar's centre slot naming the current view, with
// a caret; tapping it opens a menu of the views (icon column, the current one quietly highlighted). Same
// look as the Releases grid's view pill (releases-page.js renderViewPill), shared here so Activity, Fans
// and anything else wear it identically.
//
//   var pill = LLViewPill.mount({
//     id: 'activity',                                   // one pill per page
//     items: [{ key: 'overview', label: 'Overview', icon: 'bi-grid' }, …],
//     current: 'overview',
//     onSelect: function (key) { … },
//   });
//   pill.update({ items, current });                  // re-render (e.g. a tab became available)
//
// The top bar's centre slot is cleared on every SPA navigation (spa-navigation.js), so each page mounts
// its pill when it runs; mounting again on the same page just re-renders.
(function () {
  if (window.LLViewPill) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function closeMenu() {
    var m = document.getElementById('llViewPillMenu');
    if (m) { if (m._off) m._off(); m.remove(); }
  }

  function openMenu(btn, state) {
    if (document.getElementById('llViewPillMenu')) { closeMenu(); return; }
    var menu = document.createElement('div');
    menu.id = 'llViewPillMenu';
    menu.className = 'release-context-menu is-visible ll-view-menu';
    menu.setAttribute('role', 'menu');
    menu.innerHTML = state.items.map(function (it) {
      var on = it.key === state.current;
      return '<button type="button" role="menuitem" class="release-context-item' + (on ? ' is-current' : '') + '" data-key="' + esc(it.key) + '"' +
        (on ? ' aria-current="true"' : '') + '><i class="bi ' + esc(it.icon || 'bi-circle') + '"></i>' + esc(it.label) + '</button>';
    }).join('');
    document.body.appendChild(menu);
    var r = btn.getBoundingClientRect();
    var left = r.left + r.width / 2 - menu.offsetWidth / 2;
    menu.style.left = Math.max(8, Math.min(left, window.innerWidth - menu.offsetWidth - 8)) + 'px';
    menu.style.top = (r.bottom + 6) + 'px';
    var onAway = function (e) { if (!menu.contains(e.target) && !btn.contains(e.target)) closeMenu(); };
    var onKey = function (e) { if (e.key === 'Escape') closeMenu(); };
    setTimeout(function () {
      document.addEventListener('click', onAway, true);
      document.addEventListener('keydown', onKey, true);
    }, 0);
    menu._off = function () {
      document.removeEventListener('click', onAway, true);
      document.removeEventListener('keydown', onKey, true);
    };
    menu.querySelectorAll('[data-key]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.key;
        closeMenu();
        if (k !== state.current && state.onSelect) state.onSelect(k);
      });
    });
  }

  // CHIPS (James 2026-10-09: "instead of a dropdown, chips"): every view is a chip in a row, the current
  // one the dark chip, the rest outlined; one tap switches. Same chip look as the Releases grid's chips.
  function renderChips(bar, state) {
    bar.classList.add('ll-view-chips');
    bar.setAttribute('role', 'tablist');
    bar.innerHTML = state.items.map(function (it) {
      var on = it.key === state.current;
      return '<button type="button" role="tab" class="ll-chip' + (on ? ' is-active' : '') + '" data-key="' + esc(it.key) + '" aria-selected="' + (on ? 'true' : 'false') + '">' +
        esc(it.label) + '</button>';
    }).join('');
    bar.querySelectorAll('.ll-chip').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.key;
        if (k === state.current) return;
        // Light the tapped chip at once (the view behind it may take a moment to load).
        bar.querySelectorAll('.ll-chip').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        if (state.onSelect) state.onSelect(k);
      });
    });
  }

  // PHONES CYCLE (James 2026-11-01, the Releases grid's pill): one pill naming the view; a tap steps to the next view,
  // the chevron opens the list.
  function cycles(state) {
    return state.items.length > 1 && window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
  }
  function render(bar, state) {
    bar._state = state;   // a re-mount brings new views; the pill's tap reads them from here
    if (state.mode !== 'menu' && !cycles(state)) { renderChips(bar, state); return; }
    var cur = state.items.find(function (it) { return it.key === state.current; }) || state.items[0];
    if (!cur) { bar.innerHTML = ''; return; }
    var live = bar.querySelector('.ll-view-pill');
    if (live && live.dataset.key === cur.key) return;
    // Same pill, next view: the icon and label swap with a quick fade (as the Releases pill morphs).
    if (live && live.animate) {
      var parts = live.querySelectorAll('.ll-view-pill-icon, .ll-view-pill-label');
      live.dataset.key = cur.key;
      var out = Array.prototype.map.call(parts, function (el) { return el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 110, fill: 'forwards' }); });
      setTimeout(function () {
        var icon = live.querySelector('.ll-view-pill-icon'), label = live.querySelector('.ll-view-pill-label');
        if (icon) icon.className = 'bi ' + (cur.icon || 'bi-circle') + ' ll-view-pill-icon';
        if (label) label.textContent = cur.label;
        out.forEach(function (a) { try { a.cancel(); } catch (_) {} });
        Array.prototype.forEach.call(parts, function (el) { el.animate([{ opacity: 0, transform: 'scale(0.6)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 220, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }); });
      }, 110);
      return;
    }
    bar.innerHTML = '<button type="button" class="ll-view-pill" aria-haspopup="menu" data-key="' + esc(cur.key) + '">' +
      '<i class="bi ' + esc(cur.icon || 'bi-circle') + ' ll-view-pill-icon" aria-hidden="true"></i>' +
      '<span class="ll-view-pill-label">' + esc(cur.label) + '</span>' +
      '<i class="bi bi-chevron-down ll-view-pill-caret" aria-hidden="true"></i></button>';
    var btn = bar.querySelector('.ll-view-pill');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var st = bar._state;
      // Phones: the chevron or anywhere in the pill's RIGHT half opens the list; the left half cycles.
      var pr = btn.getBoundingClientRect();
      if (!cycles(st) || (e.target.closest && e.target.closest('.ll-view-pill-caret')) || e.clientX > pr.left + pr.width / 2) { openMenu(btn, st); return; }
      closeMenu();
      var i = st.items.findIndex(function (it) { return it.key === st.current; });
      var next = st.items[(i + 1) % st.items.length];
      st.current = next.key;
      render(bar, st);
      if (st.onSelect) st.onSelect(next.key);
    });
  }

  // Phones hide the desktop top bar, so the chips live in the phone top bar's centre slot there.
  var phoneMq = window.matchMedia('(max-width: 767.98px)');
  function hostEl() {
    return (phoneMq.matches && document.getElementById('mobileTopBarCenter')) || document.getElementById('topBarCenter');
  }
  // Crossing the breakpoint (rotation, window resize) carries the mounted bar to the other slot.
  function rehome() {
    var host = hostEl();
    var bar = document.querySelector('.ll-view-pill-bar');
    if (host && bar && bar.parentNode !== host) host.insertBefore(bar, host.firstChild);
  }
  if (phoneMq.addEventListener) phoneMq.addEventListener('change', rehome);

  window.LLViewPill = {
    mount: function (opts) {
      var host = hostEl();
      if (!host || !opts || !Array.isArray(opts.items)) return null;
      closeMenu();
      // Only the pill's own bar is replaced: a page may sit its controls beside the pill in the same slot
      // (Activity's release / dates / export). The SPA clears the whole slot on every navigation anyway.
      var bar = host.querySelector('.ll-view-pill-bar');
      if (!bar || bar.dataset.id !== String(opts.id || '')) {
        if (bar) bar.remove();
        bar = document.createElement('div');
        bar.className = 'll-view-pill-bar';
        bar.dataset.id = String(opts.id || '');
        host.insertBefore(bar, host.firstChild);
      }
      var state = { items: opts.items, current: opts.current, onSelect: opts.onSelect, mode: opts.mode || 'chips' };
      render(bar, state);
      return {
        update: function (next) {
          if (next && next.items) state.items = next.items;
          if (next && next.current != null) state.current = next.current;
          render(bar, state);
        },
      };
    },
  };
})();
